import React, { useEffect, useState } from 'react';
import API from '../../../api-graphql';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm';
import { Button, CircularProgress, Grid } from '@material-ui/core';
import API_REST from '../../../api-rest-uruk';
import { useTranslation } from 'react-i18next';
import LoadingCard from '../../UI/LoadingCard';
import AlertDialog from '../../UI/AlertDialog';
import { CONSTANTS } from '../../../constants/constants';
import { useHistory, useParams } from 'react-router';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative'
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2)
  },
  containerImages: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: '15px'
  },
  containerImage: {
    width: '60%'
  },
  containerButtom: {
    padding: '20px'
  },
  containerButtoms: {
    display: 'flex'
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center'
  }
}));

function DetailIdentityBioadmin () {
  const { flowId, stepId, userId } = useParams();
  const history = useHistory();
  const classes = useStyles();
  const [userState, setUserState] = useState({ userInfo: {}, infoFlow: {} });
  const [loading, setLoading] = useState(true);
  const [updatingUser, setUpdatingUser] = useState(false);
  const [changeStatusDialog, setChangeStatusDialog] = useState(false);
  const [status, setStatus] = useState('');
  const { t } = useTranslation();
  const { infoFlow: { step } } = userState;

  const getIdentities = async () => API.getUser(userId).then(data => data.data.getUser).catch(error => error);
  const getData = async () => API_REST.getDataFromFlowAndStep({ flowId, stepId });

  const fetchAll = async () => {
    try {
      const [userInfo, infoFlow] = await Promise.all([getIdentities(), getData()]);
      setUserState({ userInfo, infoFlow: { ...infoFlow.data } });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAll();
  }, []);

  const changeStatusOfUser = async (choise) => {
    const { subgroups } = userState.userInfo;
    userState.userInfo.status = status;
    delete userState.userInfo.flow;
    setChangeStatusDialog(false);
    if (choise) {
      setUpdatingUser(true);
      await API.updateUser(userState.userInfo, subgroups)
        .then(async () => {
          setUpdatingUser(false);
        }).catch((err) => {
          console.error(err);
          setUpdatingUser(false);
        });
    }
  };

  if (loading) return <LoadingCard open={loading} loading={loading} />;

  return (
    <>
      <div className={classes.containerButtom}>
        <Button variant='outlined' color='primary' onClick={() => history.goBack()}>
          {t('processDetail:back')}
        </Button>
      </div>
      <Grid container>
        <Grid item xs={2}>
          {updatingUser
            ? <div className={classes.circularProgress}><CircularProgress /></div>
            : <AddressForm userState={userState} />}
          <div className={classes.containerButtoms}>
            <div style={{ padding: '10px' }}>
              <Button variant='contained' color='primary' onClick={() => {
                setStatus(CONSTANTS.IDENTITY.STATUS.VERIFIED);
                setChangeStatusDialog(true);
              }}>
                {t('identityListView:acceptIdentity')}
              </Button>
            </div>
            <div style={{ padding: '10px' }}>
              <Button variant='contained' color='primary' onClick={() => {
                setStatus(CONSTANTS.IDENTITY.STATUS.REJECTED);
                setChangeStatusDialog(true);
              }}>
                {t('identityListView:rejectIdentity')}
              </Button>
            </div>
          </div>
        </Grid>
        <Grid item xs={5} >
          <div className={classes.containerImages}>
            <div className={classes.containerImage}>
              <Typography>{t('identityListView:frontDocument')}</Typography>
              <img width='100%' height='auto' src={step && step.media.downloadFrontURL} />
            </div>
            <div className={classes.containerImage}>
              <Typography>{t('identityListView:backDocument')}</Typography>
              <img width='100%' height='auto' src={step && step.media.downloadBackURL} />
            </div>
            <div className={classes.containerImage}>
              <Typography>{t('identityListView:faceSmile')}</Typography>
              <img width='100%' height='auto' src={step && step.media.downloadFaceURLsmile} />
            </div>
            <div className={classes.containerImage}>
              <Typography>{t('identityListView:faceLookRight')}</Typography>
              <img width='100%' height='auto' src={step && step.media.downloadFaceURLlookRight} />
            </div>
            <div className={classes.containerImage}>
              <Typography>{t('identityListView:faceOpenMouth')}</Typography>
              <img width='100%' height='auto' src={step && step.media.downloadFaceURLopenMouth} />
            </div>
          </div>
        </Grid>
        <Grid item xs={5}>
          <div className={classes.containerImages}>
            <Typography align='center'>{t('identityListView:processRecording')}</Typography>
            <div className={classes.containerImage}>
              <video width='100%' height='auto' controls>
                <source src={step && step.media.downloadVideoURL} type='video/webm' />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </Grid>
      </Grid>
      {changeStatusDialog &&
        <AlertDialog
          description={t('documentMenu:createFlowConfirmationMessage')}
          callbackFunc={changeStatusOfUser}
          open={changeStatusDialog}
          setOpen={setChangeStatusDialog}
          customAccept={t('alertDialog:yes')}
          customCancel={t('alertDialog:no')}
          closeFun
        />}
    </>
  );
}

export default DetailIdentityBioadmin;
